

































































































































































































































































































































































import Vue from "vue";
import store, {
  GeneralIngoingInvoiceEditModelStore,
} from "../generalIngoingInvoiceEditModel/services/GeneralIngoingInvoiceEditModelStore";
import store2, { GeneralIngoingInvoiceStore } from "../generalIngoingInvoice/services/GeneralIngoingInvoiceStore";
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from "@progress/kendo-data-query";
import flowStore, { InvoiceFlowStore } from "../invoiceFlow/services/InvoiceFlowStore";
import FlowPaymentInfoView from "../invoiceFlow/views/FlowPaymentInfoView.vue";
import configuration, { AppConfiguration } from "@/models/Configuration";
import MoneyDisplay from "../../components/MoneyDisplay.vue";
import Tooltip from "@/components/Tooltip.vue";
import InvoiceStockModfierGenisView from "@/modules/incomingInvoice/invoiceStockModification/views/InvoiceStockModfierGenisView.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import InvoiceBrowserExtraFilter from "@/modules/invoiceBrowser/InvoiceBrowserExtraFilter.vue";
import ApiSearch, { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import dayjs from "dayjs";
import eventBus from "@/services/eventBus";
import DateInput from "@/components/DateInput.vue";
import CheckBox from "@/components/CheckBox.vue";
import GenoEInvoiceDocuments from "@/modules/kanri/components/GenoEInvoiceDocuments.vue";
import EmailPicker from "@/modules/bankStatement/views/EmailPicker.vue";
import http, { checkResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import pStore, {
  PaymentModeStore,
} from "@/modules/paymentMode/services/PaymentModeStore";
import { t } from "@/plugins/i18n";

interface Data {
  configuration: AppConfiguration;
  store: GeneralIngoingInvoiceEditModelStore;
  store2: GeneralIngoingInvoiceStore; // miert kellett 2 store?
  flowStore: InvoiceFlowStore;
  filter: CompositeFilterDescriptor;
  extraFilter: CompositeFilterDescriptor;
  sort: SortDescriptor[];
  loading: boolean;
  pStore: PaymentModeStore;
}

interface Methods {
  // TODO InvoiceBrowserModel -t fel kéne venni az any-k helyett
  showDetails(item: any): void;
  editInvoice(item: any): void;
  editDpaymInvoice(item: number, partner: number): void;
  editPreDpaymInvoice(item: number): void;
  convertToDate(dateString: string): string;
  handleExtraFilterToggle(isVisible: boolean): void;
  handleResetFiltering(): void;
  syncInvoiceFilter(): void;
  refreshApiSearch(): void;
  showInvImage(item: any): void;
  showResendEInvoice(item: any): void;
  cancelResendEInvoice(item: any): void;
  sendResendEInvoice(item: any): Promise<void>;
  hasSourceNoto(item: any): boolean;
  resendDocId(item: any): number;
  resendDocTable(item: any): string;
  viewButtonClick(): void;
}

interface Computed {
  columns: ApiSearchColumn[];
  viewButtonText: string | null;
  typeLabel: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    FlowPaymentInfoView,
    MoneyDisplay,
    InvoiceStockModfierGenisView,
    Tooltip,
    ApiSearchPage,
    InvoiceBrowserExtraFilter,
    CheckBox,
    DateInput,
    EmailPicker,
    GenoEInvoiceDocuments,
  },

  data: () => ({
    configuration,
    store,
    store2,
    flowStore,
    filter: {
      logic: "and",
      filters: [],
    },
    extraFilter: {
      logic: "and",
      filters: [],
    },
    sort: [],
    loading: false,
    pStore
  }),

  async beforeMount() {
    // be kell várni az értékkészleteket a státusz szűrésnél
    this.loading = true;

    try {
      if (!this.configuration.operel) {
        await Promise.all([
          this.store.loadAccountStatuses(),
          this.store.loadStatusNames(),
          this.store2.loadTypes(),
          /*a flowstatus-t manualisan beallitjuk a store-ban */
        ]);
      } else {
        await Promise.all([this.store.loadAccountStatuses(), this.store.loadStatusNames()]);
      }

      if (this.pStore.paymentModesForFilter.length < 2) {
        await this.pStore.loadPaymentModesForFilter();
      }

    } catch (error) {
      console.error(error);
      eventBus.$emit("error", t("InvoiceBrowser_HibaTortentAzAdatokLekerdezesekor"));
    } finally {
      this.loading = false;
    }
  },

  mounted(){
    const oneYearAgo = new Date();
    // oneYearAgo.setFullYear(new Date().getFullYear() - 1);
    oneYearAgo.setFullYear(new Date().getFullYear() - (configuration.sysParams.invBrowserDefFromYearFilter || 1));

    (this.store2.eFilters.filters.invDateFrom as any).value = oneYearAgo.toISOString().split('T')[0].replaceAll('-', '.'); // ennél a dátumnál frissebb számlákat kérünk le a backendről
  },

  beforeDestroy() {
    this.store.clearStatuses();
    this.handleResetFiltering();
  },

  computed: {
    columns(){
      return this.$route.params.typeFilter == 'all' ? [
      {
        cell: "invoiceDetailsTemplate",
        filterable: false,
      },
      {
        cell: "invoiceInvImageCommandTemplate",
        filterable: false,
      },
      {
        cell: "resendEInvoiceCommandTemplate",
        filterable: false,
      },
      {
        field: "id",
        title: t("Azonosito"),
        cell: "IDTemplate",
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      { field: "prefix", title: t("Prefix"), cell: "prefixTemplate" },
      {
        field: "invoiceNo",
        title: t("BizonylatSzam"),
        cell: "invoiceNoTemplate",
      },
      {
        field: "partner",
        title: t("PartnerID"),
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      {
        field: "partnerName",
        title: t("Partner"),
        headerClass: "geniLabel",
      },
      {
        field: "invoiceTypeName",
        title: t("SzamlaTipusa"),
      },
      {
        field: "paymentModeName",
        title: t("FizetesiMod"),
        multiselect: true,
        multiselectField: "pmodes",
        multiselectOptions: this.pStore.paymentModesForFilter.map((x) => ({
          text: x.name,
          value: x.id,
        })),
        multiselectSelect: this.pStore.paymentModesForFilter.map((x) => x.id),
      },
      {
        field: "dpaymInv",
        title: t("ElolegSzamla"),
        cell: "dpaymTemplate",
        sortable: false,
      },
      {
        field: "preDpaymInv",
        title: t("Elolegbekero"),
        cell: "preDpaymTemplate",
        sortable: false,
      },
      {
        field: "invoiceDate",
        title: t("SzamlaDatuma"),
        cell: "invoiceDateTemplate",
        filterable: false,
      },
      {
        field: "payTerm",
        title: t("FizetesiHatarido"),
        cell: "payTermTemplate",
        filterable: false,
      },
      {
        field: "crediting",
        title: t("InvoiceBrowser_JovairoJovairt"),
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedCrediting",
        multiselectOptions: [{text: '-', value: '-'}, {text: t("Jovairo"), value: 'Jóváíró'}, { text: t("Jovairt"), value: 'Jóváírt'}],
      },
      {
        field: "statusName",
        title: t("Statusz"),
      },
      {
        field: "navStatusName",
        title: t("InvoiceBrowser_NAVStatusz"),
      },
      {
        field: "divItem",
        title: t("InvoiceBrowser_Uzletag"),
      },
      {
        field: "currTotal",
        cell: "bruttoTemplate",
        title: t("Brutto"),
        fieldClass: "align__right",
        headerClass: "align__right",
      },
      {
        field: "currPaymSum",
        cell: "sumpayTemplate",
        title: t("InvoiceBrowser_EddigFizetett"),
      },
      {
        field: "invCurrency",
        title: t("Penznem"),
        cell: "currencyTemplate",
      },
      {
        field: "shipDate",
        title: t("TeljesitesDatuma"),
        cell: "shipDateTemplate",
        filterable: false,
      },
      {
        field: "regDate",
        title: t("IktatasDatuma"),
        cell: "regDateTemplate",
        filterable: false,
      },
      {
        field: "flowModDate",
        title: t("ModositasDatuma"),
        cell: "flowModDateTemplate",
        filterable: false,
      },
      {
        field: "flowUserName",
        title: t("Modosito"),
      },
      {
        title: t("KonyvelesiStatusz"),
        field: "accStatusName",
        cell: "accStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedAccStatuses",
        multiselectOptions: store.accountStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "bodyNo",
        title: t("Alvazszam"),
        sortable: false,
      },
      {
        title: t("InvoiceBrowser_SzamlaJovahagyasiStatusz"),
        field: "preStatusName",
        cell: "preStatusNameTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedPreStatuses",
        multiselectOptions: store.statusNames.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "flowStatusName",
        title: t("WorkflowStatusz"),
        cell: "flowStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedFlowStatuses",
        multiselectOptions: store.flowStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "daysSpentInStatus",
        title: t("StatuszbanEltoltottIdo"),
        cell: "daysSpentTemplate",
      },
      {
        field: "isIntrastat",
        title: t("InvoiceBrowser_LehetsegesIntrastat"),
        cell: "isIntrastat",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIntrastat",
        multiselectOptions: [
          { text: t("Nem"), value: 0 },
          { text: t("Igen"), value: 1 },
        ],
      },
      {
        field: "isIndirectNoserv",
        title: t("InvoiceBrowser_NemKeszletesIntrastatos"),
        cell: "isIndirectNoserv",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIndirectNoserv",
        multiselectOptions: [
          { text: t("Nem"), value: 0 },
          { text: t("Igen"), value: 1 },
        ],
      },
      {
        field: "intrastatIds",
        title: t("InvoiceBrowser_IntrastatAzonositok"),
        cell: "intrastatIds",
      },
      {
        field: "remark1",
        title: t("Megjegyzes"),
        fieldClass: "remark",
      },
    ] : [
      {
        cell: "invoiceDetailsTemplate",
        filterable: false,
      },
      {
        cell: "invoiceInvImageCommandTemplate",
        filterable: false,
      },
      {
        cell: "resendEInvoiceCommandTemplate",
        filterable: false,
      },
      {
        field: "id",
        title: t("Azonosito"),
        cell: "IDTemplate",
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      { field: "prefix", title: t("Prefix"), cell: "prefixTemplate" },
      {
        field: "invoiceNo",
        title: t("BizonylatSzam"),
        cell: "invoiceNoTemplate",
      },
      {
        field: "partner",
        title: t("PartnerID"),
        fieldClass: "align__field__center",
        headerClass: "align__center",
      },
      {
        field: "partnerName",
        title: t("Partner"),
        headerClass: "geniLabel",
      },
      {
        field: "invoiceTypeName",
        title: t("SzamlaTipusa"),
      },
      {
        field: "paymentModeName",
        title: t("FizetesiMod"),
        multiselect: true,
        multiselectField: "pmodes",
        multiselectOptions: this.pStore.paymentModesForFilter.map((x) => ({
          text: x.name,
          value: x.id,
        })),
        multiselectSelect: this.pStore.paymentModesForFilter.map((x) => x.id),
      },
      {
        field: "dpaymInv",
        title: t("ElolegSzamla"),
        cell: "dpaymTemplate",
        sortable: false,
      },
      {
        field: "preDpaymInv",
        title: t("Elolegbekero"),
        cell: "preDpaymTemplate",
        sortable: false,
      },
      {
        field: "invoiceDate",
        title: t("SzamlaDatuma"),
        cell: "invoiceDateTemplate",
        filterable: false,
      },
      {
        field: "payTerm",
        title: t("FizetesiHatarido"),
        cell: "payTermTemplate",
        filterable: false,
      },
      {
        field: "crediting",
        title: t("InvoiceBrowser_JovairoJovairt"),
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedCrediting",
        multiselectOptions: [{text: '-', value: '-'}, {text: t("Jovairo"), value: 'Jóváíró'}, { text: t("Jovairt"), value: 'Jóváírt'}],
      },
      {
        field: "statusName",
        title: t("Statusz"),
      },
      {
        field: "navStatusName",
        title: t("InvoiceBrowser_NAVStatusz"),
      },
      {
        field: "currTotal",
        cell: "bruttoTemplate",
        title: t("Brutto"),
        fieldClass: "align__right",
        headerClass: "align__right",
      },
      {
        field: "currPaymSum",
        cell: "sumpayTemplate",
        title: t("InvoiceBrowser_EddigFizetett"),
      },
      {
        field: "invCurrency",
        title: t("Penznem"),
        cell: "currencyTemplate",
      },
      {
        field: "shipDate",
        title: t("TeljesitesDatuma"),
        cell: "shipDateTemplate",
        filterable: false,
      },
      {
        field: "regDate",
        title: t("IktatasDatuma"),
        cell: "regDateTemplate",
        filterable: false,
      },
      {
        field: "flowModDate",
        title: t("ModositasDatuma"),
        cell: "flowModDateTemplate",
        filterable: false,
      },
      {
        field: "flowUserName",
        title: t("Modosito"),
      },
      {
        title: t("KonyvelesiStatusz"),
        field: "accStatusName",
        cell: "accStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedAccStatuses",
        multiselectOptions: store.accountStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "bodyNo",
        title: t("Alvazszam"),
        sortable: false,
      },
      ...(this.$route.params.typeFilter === "outgoing"
        ? [
            {
              field: "regNum",
              title: t("Rendszam"),
              sortable: false,
            },
          ]
        : []),
      // a Kanri munkalapszám Kanri-működésű rendszerben, GENO számlákra értelmezett
      ...(this.$route.params.typeFilter === "outgoing" && this.configuration.sysParams.isKanriEnabled
        ? [
            {
              field: "worksheetNo",
              title: t("InvoiceBrowser_KanriMunkalapszam"),
              sortable: false,
            },
          ]
        : []),
      {
        title: t("InvoiceBrowser_SzamlaJovahagyasiStatusz"),
        field: "preStatusName",
        cell: "preStatusNameTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedPreStatuses",
        multiselectOptions: store.statusNames.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "flowStatusName",
        title: t("WorkflowStatusz"),
        cell: "flowStatusTemplate",
        fieldClass: "align__field__center",
        multiselect: true,
        multiselectField: "selectedFlowStatuses",
        multiselectOptions: store.flowStatuses.map((x) => ({ text: x.name, value: x.id })),
      },
      {
        field: "daysSpentInStatus",
        title: t("StatuszbanEltoltottIdo"),
        cell: "daysSpentTemplate",
      },
      {
        field: "isIntrastat",
        title: t("InvoiceBrowser_LehetsegesIntrastat"),
        cell: "isIntrastat",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIntrastat",
        multiselectOptions: [
          { text: t("Nem"), value: 0 },
          { text: t("Igen"), value: 1 },
        ],
      },
      {
        field: "isIndirectNoserv",
        title: t("InvoiceBrowser_NemKeszletesIntrastatos"),
        cell: "isIndirectNoserv",
        type: ColumnType.Center,
        multiselect: true,
        multiselectField: "selectedIsIndirectNoserv",
        multiselectOptions: [
          { text: t("Nem"), value: 0 },
          { text: t("Igen"), value: 1 },
        ],
      },
      {
        field: "intrastatIds",
        title: t("InvoiceBrowser_IntrastatAzonositok"),
        cell: "intrastatIds",
      },
      {
        field: "remark1",
        title: t("Megjegyzes"),
        fieldClass: "remark"
      },
    ];
    },

    viewButtonText() {
      if (this.$route.params.typeFilter === "incoming") return t("InvoiceBrowser_ValtasAMindenSzamlaNezetre");
      if (this.$route.params.typeFilter === "outgoing") return t("InvoiceBrowser_ValtasAMindenSzamlaNezetre");
      if (this.$route.params.typeFilter === "all") return null;
      return null;
    },

    typeLabel() {
      if (this.$route.params.typeFilter === "incoming") return t("InvoiceBrowser_BejovoSzamlak");
      if (this.$route.params.typeFilter === "outgoing") return t("InvoiceBrowser_KimenoSzamlak");
      if (this.$route.params.typeFilter === "all") return t("InvoiceBrowser_MindenSzamla");
      return "";
    },
  },

  methods: {
    editInvoice(item) {
      if (item.prefix === "GENI") {
        if (item.preDownPayment){
          this.$router.push(`/down-payment/edit/${item.id}`);
        } else {
          const path = configuration.invoiceFlow.enabled
          ? item.isStockCorrection
            ? `/uninvoiced-stock-correction/edit/${item.id}`
            : `/general-incoming-invoice/flow/edit/${item.id}/${item.flowStatus}`
          : `/general-incoming-invoice/edit/${item.partner}/${item.id}`;

        this.$router.push(path);
        }
      }

      if (item.prefix === "NOTO") {
        this.$router.push(`/noto/${item.id}`);
      }
    },
    editDpaymInvoice(item, partner) {
      const path = configuration.invoiceFlow.enabled
        ? `/general-incoming-invoice/flow/edit/${item}/4`
        : `/general-incoming-invoice/edit/${partner}/${item}`;

      this.$router.push(path);
    },

    editPreDpaymInvoice(item) {
      const path = `/down-payment/edit/${item}`;

      this.$router.push(path);
    },

    showDetails(item: any) {
      item.expanded = !item.expanded;
    },

    convertToDate(dateString) {
      if (dayjs(dateString).isValid()) {
        return dayjs(dateString).format("YYYY-MM-DD");
      }
      return "-";
    },

    //szűrő gombnyomás
    handleExtraFilterToggle(isVisible: boolean) {
      if (!isVisible) {
        this.handleResetFiltering();
        this.refreshApiSearch();
      }
    },

    // szűrők törlése gombnyomás
    handleResetFiltering() {
      this.store2.resetExtraFilter();
    },

    syncInvoiceFilter() {
      (this.store2.eFilters.filters.invoiceFilter as any).value =
        this.$route.params.filtered === "filtered" && this.store2.invoiceFilter.length > 0
          ? this.store2.invoiceFilter
          : null;
    },

    refreshApiSearch() {
      const childComponentInstance = this.$refs.asref;
      if (childComponentInstance) {
        (this.$refs.asref as any).refreshClick();
      }
    },

    async showInvImage(item) {
      await this.store.openInvoiceImage(item.id, item.prefix);
    },

    showResendEInvoice(item: any) {
      if (item.resendMode) {
        this.cancelResendEInvoice(item);
        return;
      }
      this.$set(item, "resendMode", true);
      this.$set(item, "resendEmails", []);
      this.$set(item, "expanded", true);
    },

    cancelResendEInvoice(item: any) {
      this.$set(item, "resendMode", false);
      this.$set(item, "resendEmails", []);
      this.$set(item, "expanded", false);
    },

    // Ha van forrás NOTO (rmaccnoto_dpaym alapján), ahhoz csatolunk; egyébként magához a számlához.
    hasSourceNoto(item: any): boolean {
      return (item.sourceNoto ?? 0) >= 2;
    },

    resendDocId(item: any): number {
      return this.hasSourceNoto(item) ? item.sourceNoto : item.id;
    },

    resendDocTable(item: any): string {
      return this.hasSourceNoto(item) ? "hmouinotinvoice" : (item.documentTable || "hmouigeninvoice");
    },

    async sendResendEInvoice(item: any) {
      try {
        const emails: string[] = (item.resendEmails || []).map((e: any) => e.email);
        if (emails.length === 0) {
          eventBus.$emit("error", t("InvoiceBrowser_NincsKivalasztottEmailCim"));
          return;
        }
        await http
          .put<ApiResponse<{}>>(`invoice-browser/resend-einvoice/${item.prefix}/${item.id}`, { emails: emails })
          .then(checkResponse);
        eventBus.$emit("success", t("InvoiceBrowser_ESzamlaSikeresenUjrakuldve"));
      } catch (ex) {
        console.log(ex);
        eventBus.$emit("error", t("InvoiceBrowser_NemSikerultAzESzamlaUjrakuldese"));
      } finally {
        this.cancelResendEInvoice(item);
      }
    },

    viewButtonClick() {
      this.$router.push(`/invoice-browser/all`);
    },
  },
});
